export function buildFullName({
	firstName,
	middleName,
	lastName,
	surname
}: {
	firstName?: string
	middleName?: string
	lastName?: string
	surname?: string
}) {
	// Inicializamos un array vacío para los nombres
	const nameParts = []

	// Solo agregamos los nombres que no sean undefined o null
	if (firstName) nameParts.push(firstName)
	if (middleName) nameParts.push(middleName)
	if (lastName) nameParts.push(lastName)
	if (surname) nameParts.push(surname)

	// Unimos los nombres con un espacio
	return nameParts.join(' ')
}

export const capitalizeFirstLetter = (text: string) => {
	if (!text) return ''

	return text
		.toLowerCase()
		.split(' ')
		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ')
		.trim()
}

export const arrayPacs: string[] = ['PSC03', 'PSC02', 'PSC04']

export const NO_EXECUTE_CONTENTFULL_ROUTES: string[] = ['/par-q-public', '/par-q']
